/* ==========================================================================
   UNFORDS — utilidades de rendimiento
   --------------------------------------------------------------------------
   Se carga en todas las páginas y no dibuja nada: solo evita trabajo inútil.

   `window.unfOnResize(fn)` agrupa los avisos de cambio de tamaño.
   El navegador puede lanzar `resize` decenas de veces por segundo mientras
   se arrastra la ventana o se gira el celular. Sin control, cada aviso
   ejecuta medidas del layout y provoca tirones. Aquí se acumulan y se
   ejecutan una sola vez por fotograma.
   ========================================================================== */
(function () {
  'use strict';

  var callbacks = [];
  var pending = false;

  function flush() {
    pending = false;
    for (var i = 0; i < callbacks.length; i++) {
      try {
        callbacks[i]();
      } catch (e) {
        /* Un fallo en una sección no debe tumbar a las demás. */
      }
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(flush);
  }

  window.unfOnResize = function (fn) {
    if (typeof fn !== 'function') return function () {};
    callbacks.push(fn);
    if (callbacks.length === 1) {
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('orientationchange', schedule, { passive: true });
    }
    return function unsubscribe() {
      var i = callbacks.indexOf(fn);
      if (i > -1) callbacks.splice(i, 1);
    };
  };
})();
